export default __webpack_public_path__ + "static/media/coupon.c82c6178.png";